import useSWRImmutable from 'swr/immutable';
import AccommodationService from '@/services/AccommodationService';

const useAccommodationPolicies = () => useSWRImmutable(
    'accommodation-policies',
    AccommodationService.getPaymentOptions,
);

export default useAccommodationPolicies;
